export type OfflineBootstrapPermissionScope = {
  permissions: readonly string[]
  isSuperAdmin: boolean
}

const hasAnyPermission = (
  scope: OfflineBootstrapPermissionScope,
  permissions: readonly string[],
): boolean => scope.isSuperAdmin || permissions.some((permission) => scope.permissions.includes(permission))

export const canBootstrapPosCatalog = (scope: OfflineBootstrapPermissionScope): boolean =>
  hasAnyPermission(scope, ['process_sales'])

export const canBootstrapActiveShift = (scope: OfflineBootstrapPermissionScope): boolean =>
  hasAnyPermission(scope, ['process_sales', 'open_shift'])
